module.exports = __webpack_public_path__ + "img/zwy_TC.6c1e5df7.jpg";